var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid2X2Plus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55384 20.1497C3.09384 20.1497 2.695 19.9808 2.35734 19.643C2.0195 19.3053 1.85059 18.9065 1.85059 18.4465V5.55398C1.85059 5.09231 2.0195 4.69206 2.35734 4.35323C2.695 4.01423 3.09384 3.84473 3.55384 3.84473H20.4463C20.908 3.84473 21.3083 4.01423 21.6471 4.35323C21.9861 4.69206 22.1556 5.09231 22.1556 5.55398V18.4465C22.1556 18.9065 21.9861 19.3053 21.6471 19.643C21.3083 19.9808 20.908 20.1497 20.4463 20.1497H3.55384ZM3.55384 11.2502H8.16809V5.55398H3.55384V11.2502ZM9.66809 11.2502H14.3321V5.55398H9.66809V11.2502ZM15.8321 11.2502H20.4463V5.55398H15.8321V11.2502ZM8.16809 18.4465V12.7502H3.55384V18.4465H8.16809ZM9.66809 18.4465H14.3321V12.7502H9.66809V18.4465ZM15.8321 18.4465H20.4463V12.7502H15.8321V18.4465Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid2X2Plus);
export default __webpack_public_path__ + "static/media/grid-2x2-plus.0b2f0da0120bf7aaa5483c91fc0000ab.svg";
export { ForwardRef as ReactComponent };